/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaBepozProductSummaryCtrl
 * @description A report that replicates the Product summary from the Bepoz back office
 */
angular.module('mercury.modules.qa.wizbang')
.controller('QaWizbangVoidsCtrl', ["$filter", "reporttime", "$q", "$scope", "$http", "$stateParams", "title", "userinfo", "settings", function($filter, reporttime, $q, $scope, $http, $stateParams, title, userinfo, settings) {
  title.set('Voids / Wastage Report');

  $scope.companyName = userinfo.companyName();

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaWizbangVoids', {
    params: {startTime: reporttime.start(), endTime: reporttime.end()}}
  );

  $scope.reportLines = [];
  $scope.qtyVoided = 0;
  $scope.qtyWasted = 0;
  $scope.nett = 0;

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);

    $scope.reportLines = response.data.lines;

    angular.forEach(response.data.lines, function(item) {
      $scope.qtyVoided += item.qtyVoided;
      $scope.qtyWasted += item.qtyWasted;
      $scope.nett += item.nett;
    });
  });

}]);
